/* 3D Modart — Theme JS */
(function () {
  'use strict';

  // ===== Sticky header scroll state =====
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ===== Mobile drawer =====
  const drawer = document.getElementById('MobileDrawer');
  const openDrawer = document.querySelector('[data-drawer-open]');
  const closeDrawer = document.querySelector('[data-drawer-close]');
  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  };
  openDrawer?.addEventListener('click', () => setDrawer(true));
  closeDrawer?.addEventListener('click', () => setDrawer(false));

  // ===== Collection filter drawer (mobile) =====
  const filterPanel = document.querySelector('.collection-filters');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose = document.querySelector('[data-filter-close]');
  filterToggle?.addEventListener('click', () => filterPanel?.classList.add('is-open'));
  filterClose?.addEventListener('click', () => filterPanel?.classList.remove('is-open'));

  // ===== Product variant selector =====
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-product-price]');
    const compareEl = form.querySelector('[data-product-compare]');
    const submitBtn = form.querySelector('[data-product-submit]');
    const submitText = form.querySelector('[data-product-submit-text]');
    const variantsData = form.querySelector('[data-variants-json]');
    if (!variantsData) return;
    let variants;
    try { variants = JSON.parse(variantsData.textContent); } catch (e) { return; }

    const pills = form.querySelectorAll('.option-pill input[type="radio"]');

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: form.dataset.currency || 'EUR'
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
    };

    const findVariant = () => {
      const selected = [];
      form.querySelectorAll('[data-option-position]').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    };

    const updateActiveClasses = () => {
      form.querySelectorAll('.option-pill').forEach((pill) => {
        const input = pill.querySelector('input[type="radio"]');
        pill.classList.toggle('is-active', input?.checked);
      });
    };

    const updateColorWishVisibility = () => {
      const wishField = form.querySelector('[data-color-wish-field]');
      if (!wishField) return;
      const paintInput = form.querySelector('[data-option-name="bemalung"] input:checked, [data-option-name="paint"] input:checked, [data-option-name="painting"] input:checked');
      const isPainted = paintInput && /lackiert|painted|bemalt/i.test(paintInput.value);
      wishField.classList.toggle('is-visible', !!isPainted);
    };

    const update = () => {
      updateActiveClasses();
      const variant = findVariant();
      if (!variant) {
        if (submitBtn) { submitBtn.disabled = true; }
        if (submitText) submitText.textContent = 'Nicht verfügbar';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submitBtn) submitBtn.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      updateColorWishVisibility();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    pills.forEach((input) => input.addEventListener('change', update));
    update();
  });

  // ===== Product gallery =====
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (mainImg && src) {
          mainImg.src = src;
          mainImg.srcset = thumb.dataset.srcset || '';
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  // ===== Quantity buttons =====
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    wrap.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();
